import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import { useState } from 'react';
import LinkService from '../system/LinkService';
import useApiCall from '../system/useApiCall';
import AvatarDropCategoryTO from './AvatarDropCategoryTO';

interface AvatarDropCategoryDialogProps {
  editData?: AvatarDropCategoryTO;
  openDialog: boolean;
  setEditRow: React.Dispatch<React.SetStateAction<number | null>>;
  saveCount: number;
  setSaveCount: React.Dispatch<React.SetStateAction<number>>;
}

export default function AvatarDropCategoryDialog(props: AvatarDropCategoryDialogProps) {
  const apiCall = useApiCall();
  const AvatarDropCategoryDataInit: AvatarDropCategoryTO = {
    id: -1,
    categoryName: '',
  };
  const [avatarDropCategoryData, setAvatarDropCategoryData] = useState<AvatarDropCategoryTO>(
    props.editData ? props.editData : AvatarDropCategoryDataInit
  );

  React.useEffect(() => {
    if (props.editData) {
      setAvatarDropCategoryData(props.editData);
    }
  }, [props.editData]);

  const handleCancel = () => {
    handleClose();
  };

  const handleSave = () => {
    apiCall
      .post(LinkService.postAvatarDropCategory(), avatarDropCategoryData, 'Speichern erfolgreich.')
      .then((data) => {
        handleClose();
        props.setSaveCount(props.saveCount + 1);
      });
  };

  const handleClose = () => {
    setAvatarDropCategoryData(AvatarDropCategoryDataInit);
    props.setEditRow(null);
  };

  const title = avatarDropCategoryData.id === -1 ? 'Neue Drop-Kategorie hinzufügen' : 'Drop-Kategorie bearbeiten';

  return (
    <Dialog open={props.openDialog}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin='dense'
          id='categoryName'
          label='Drop-Kategorie'
          fullWidth
          variant='standard'
          value={avatarDropCategoryData.categoryName}
          onChange={(e) => setAvatarDropCategoryData({ ...avatarDropCategoryData, categoryName: e.target.value })}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>Abbrechen</Button>
        <Button onClick={handleSave}>Speichern</Button>
      </DialogActions>
    </Dialog>
  );
}
